import * as React from "react";
import { CareersHero } from "./CareersHero";
import { PerksSection } from "./PerksSection";
import { PositionsSeciton } from "./PositionsSection";
import styled from "../../styled-components";
import { Header, Footer } from "@asayinc/components";

const Wrapper = styled.div`
  overflow: hidden;
`;

export const Careers = () => (
  <Wrapper>
    <Header />
    <div role="main">
      <CareersHero />

      {/* TODO: Add this section back when receive final photo assets */}
      {/* <PhotoGrid /> */}

      <PerksSection />

      <PositionsSeciton />
    </div>
    <Footer />
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/pages/Careers/Careers.tsx